// Hocs
import asyncRoute from '../AsyncRoute'

// Exports
export function getComponent ({store}) {
  return new Promise((resolve) => {
    require.ensure([], (require) => {
      const View = require('hfty-comments-dom').CommentsManager

      resolve(View)

      /* Webpack named bundle   */
    }, 'hefty-comments')
  })
}

export default asyncRoute({getComponent, reducers: []})
